// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9ba67d1b","867":"b0627856"}[chunkId] + ".chunk.js";
};